import { BlockOutlined } from '@mui/icons-material';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {IconButton, Menu, MenuItem} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import DialogValiderBackOffice from '../../../Components/Dialogs/DialogValiderBackOffice';
import DeleteAccount from '../../../Components/shared/DeleteAccount';
import useAuth from '../../../hooks/useAuth';
import usePostRequest from '../../../hooks/usePostRequest';
import { isHttpStatusSuccess } from '../../../Utils/utils';
const EditerBackOffice = ({rowSelected,getMyCollaborators}) => {
    EditerBackOffice.propTypes = {
        rowSelected:PropTypes.any,
        getMyCollaborators:PropTypes.func,
    };
    const { postData } = usePostRequest();
    const { i18n } = useTranslation();
    const {auth} = useAuth();
    let backOfficeRole= auth?.embeddedRoles;
    const [openMenu,setOpenMenu]=useState(false);
    const [open,setOpen]=useState(false);
    async function blockUser() {
        try {
            console.log({rowSelected, bool: (rowSelected?.role?.Admin ==0 && rowSelected?.role?.littleAdmin ==0), bool2: (backOfficeRole?.Admin ==1 ||backOfficeRole?.littleAdmin==1)});
            const response = await postData({ url: '/users/blockUser', payload: {
                email: rowSelected?.email_,
                isBlocked: !rowSelected?.isBlocked,
            } });
            if (isHttpStatusSuccess(response?.responseStatus)) {
                Swal.fire({
                    title: i18n.t(response?.data?.message),
                    icon: 'success',
                    confirmButtonColor: '#5CC889',
                    confirmButtonText: 'Ok',
                }).then((result) => {
                    if(result.isConfirmed){
                        getMyCollaborators();
                    }
                });
            }
        } catch (error) {
            console.log(error);
        }
        setOpenMenu(false);
    }
    return(
        <>
            <IconButton
                onClick={()=>{
                    setOpenMenu(true);
                }}
                aria-label="more"
                id="long-button"
                aria-haspopup="true"
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                sx={{ mt: '400px',ml:'-140px' }}
                id="menu-appbar"
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                anchorEl={openMenu}
                onClose={()=>{
                    setOpenMenu(false);
                }}
                open={Boolean(openMenu)}
                PaperProps={{
                    style: {
                        width: '150px',
                        borderRadius: 0,
                    },
                }}
            >
                <MenuItem
                    onClick={()=>{
                        console.log('rowSelected',rowSelected,'condition',rowSelected?.statut!='enAttente');
                        setOpen(true);
                        setOpenMenu(false);
                    }}
                    className='B2Style'
                    disabled={((backOfficeRole?.Admin ==1 ||backOfficeRole?.littleAdmin==1) && rowSelected?.statut!='enAttente') ? false : true }
                >
                    {i18n.t('Editer')} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<ModeEditOutlinedIcon />
                </MenuItem>
                <MenuItem
                    disabled={(backOfficeRole?.Admin ==1 ||backOfficeRole?.littleAdmin==1) ? false : true }
                    className='B2Style'
                    onClick={()=>{
                        setOpenMenu(false);
                    }}
                    hidden
                >
                    <DeleteAccount
                        userEmail={rowSelected.email_}
                        refresh={getMyCollaborators}
                        content={i18n.t('Supprimer')}
                    />
                </MenuItem>
                <MenuItem
                    disabled={((backOfficeRole?.Admin ==1 ||backOfficeRole?.littleAdmin==1) && (rowSelected?.role?.Admin ==0 && rowSelected?.role?.littleAdmin ==0)) ? false : true }
                    className='B2Style'
                    onClick={blockUser}
                >
                    {rowSelected?.isBlocked ?  i18n.t('Débloquer') : i18n.t('Bloquer') } &nbsp;<BlockOutlined />
                </MenuItem>
            </Menu>
            {open &&
            <DialogValiderBackOffice
                open={open}
                setOpen={()=>{
                    setOpen(false);
                }}
                title={'Editer'}
                rowSelected={rowSelected}
                mode={'editer'}
                getMyCollaborators={getMyCollaborators}
            />}
        </>
    );
};

export default EditerBackOffice;
